module.exports = __webpack_public_path__ + "img/mentat.6b033107.svg";